<template>
  <div class="flex flex-col rounded-m bg-grey-extralight m-3">
    <div class="bg-grey-lightest rounded-t-m text-grey-darkest font-semibold p-4">Recommended Lab Tests</div>
    <div class="p-4">
      <div class="text-sm text-grey-darkest p-2" v-for="(test, index) in data.recommended_tests" :key="index">
        {{index+1}}. {{test.name}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data () {
    return {
    }
  }
}
</script>

<style>
.twd_card_24{
    display: flex; flex-shrink: 0; flex-grow: 0;
    flex-direction: column;
    border-radius: 10px;
    border: solid 1px #dae1e7;
}
.twd_card_24_header{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px 15px 0px 15px;
    margin: 0px 0px 05px 0px;
    /* font-size: 15px; */
    /* color: #333333; */
    /* font-weight: 600; */
    height: 3rem;
    border-radius: 10px 10px 0px 0px;;
    /* background-color: #dae1e7; */
}
.twd_card_24_h1{
    /* font-size: 14px; */
    /* color: #333; */
    /* font-weight: 500; */
    align-content: center;
    padding: 0px 15px 0px 15px;
    margin: 10px 0px 10px 0px;
}
.twd_card_24_footer{
    /* font-size: 10px;
    font-weight: 200; */
    /* color: #a2a2a2; */
    padding: 0px 15px 0px 15px;
    margin: 15px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Chat/LabTestCard.vue